

























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import Swiper from "@/components/Swiper/Swiper.vue";
import { swiperSlide } from "vue-awesome-swiper";
import Scroller from "@/components/Scroller/Scroller.vue";
import SkuSection from "@/components/SkuSection/SkuSection.vue";
import SkuTitle from "@/components/SkuTitle/SkuTitle.vue";
import CoinsTitle from "@/components/SkuTitle/CoinsTitle.vue";
import CoinsTitleSeparate from "@/components/SkuTitle/CoinsTitleSeparate.vue";
import NavBar from "@/components/NavBarNew/NavBar.vue";
import SpecialOffer from "@/components/SpecialOffer/SpecialOffer.vue";
import SkuSpecialTitle from "@/components/SkuTitle/SkuSpecialTitle.vue";
import UserInfo from "@/components/UserInfo/UserInfo.vue";
import InsUserGallery from "@/components/PopGallery/InsUserGallery.vue";
import MidTab from "@/components/MidTab/MidTab.vue";
import SpacerArea from "@/components/SkuTitle/SpacerArea.vue";
import {
  SHOW_SEARCH_OR_LOGIN,
  REFRESH_CURRENT_INS_UNSR_INFO,
  GETTER_CURRENT_INS_USER_INFO
} from "@/store/constants/ins_user_info_types";
import {
  GETTER_FOLLOW_OFFERS,
  GETTER_GOLDEN_FOLLOW_OFFERS,
  UPDATE_GX_SETTING_DATA,
  GETTER_ONLINE_SETTING_STATE,
  UPDATE_PAGE_SETTING_STATUS
} from "@/store/constants/setting_types";
import { showFollowDifference } from "@/services/dialog_utils";
import { Offer } from "@/services/offer/offer_handle";
import { payByAny } from "@/services/payment/payment_check/payment_check_logic";
import SelectUser from "@/components/SelectUser/SelectUser.vue";
import * as cg_user_types from "@/store/constants/cg_user_types";
import { intersection_observer } from "@/utils/intersection_observer/intersection_observer";
import BottomInfo from "@/components/BottomInfo/BottomInfo.vue";
import * as cgConst from "@/api/cg/base/cg_const";
import generator from "@/services/open_pop_up/open_generator";
import { getNotification } from "@/utils/js_bridge_info";
import { getCurrentRoute } from "@/plugins/navigation/routes";
import { goToCoinStore } from "@/utils/router_helper/index";
@Component({
  components: {
    MidTab,
    NavBar,
    Swiper,
    swiperSlide,
    Scroller,
    SkuSection,
    CoinsTitle,
    SkuTitle,
    SelectUser,
    SkuSpecialTitle,
    CoinsTitleSeparate,
    SpecialOffer,
    UserInfo,
    InsUserGallery,
    SpacerArea,
    BottomInfo
  }
})
export default class Follow extends Vue {
  @Action(SHOW_SEARCH_OR_LOGIN)
  private showSearchLogin: any;
  @Action(REFRESH_CURRENT_INS_UNSR_INFO)
  private refreshCurrentUserInfo: any;
  @Action(UPDATE_GX_SETTING_DATA)
  private updateSettingData: any;
  @Getter(GETTER_CURRENT_INS_USER_INFO)
  private currentInsUserInfo: any;
  @Getter(GETTER_FOLLOW_OFFERS)
  private followOffers: any;
  @Getter(GETTER_GOLDEN_FOLLOW_OFFERS)
  private goldenFollowOffers: any;
  @Getter(cg_user_types.GETTER_COINS)
  private userCoins: any;
  @Getter(GETTER_ONLINE_SETTING_STATE)
  private getterOnlineSettingsState?: boolean;
  @Mutation(UPDATE_PAGE_SETTING_STATUS)
  private updatePageSettingStatus?: any;

  private activeIndex = 0;
  private showInsGallery = false;
  private swiperHeight: any = "auto";
  private fixedTabBarShow: boolean = false; // 固定tabbar显示

  private tabsArr = [
    {
      label: "Followers",
      acitveColor: "#4f79ff",
      activeTextColor: "#4f79ff",
      imgUrl: require("@/assets/icons-file/tab/icon_followers2.png")
    },
    {
      label: "Golden Followers",
      acitveColor: "rgb(250,185,5)",
      showDot: false,
      activeTextColor: "rgb(250,185,5)",
      imgUrl: require("@/assets/icons-file/tab/icon_golden_followers2.png")
    }
  ];

  get currentUserIcon() {
    return (
      this.currentInsUserInfo &&
      this.currentInsUserInfo.ins_user_info &&
      this.currentInsUserInfo.ins_user_info.profile_pic_url
    );
  }

  get iapOfferList() {
    return [this.followOfferBuyIap, this.goldenFollowOfferBuyIap];
  }

  get coinOfferList() {
    return [this.followOfferBuyCoin, this.goldenFollowOfferBuyCoin];
  }

  get followOfferBuyIap() {
    if (!this.followOffers) {
      return null;
    }
    return this.followOffers.filter((item: any) => {
      return item.way === "iap";
    });
  }

  get followOfferBuyCoin() {
    if (!this.followOffers) {
      return null;
    }
    return this.followOffers.filter((item: any) => {
      return item.way === "coin" && item.effect !== 0;
    });
  }

  get goldenFollowOfferBuyIap() {
    if (!this.goldenFollowOffers) {
      return null;
    }
    return this.goldenFollowOffers.filter((item: any) => {
      return item.way === "iap";
    });
  }

  get goldenFollowOfferBuyCoin() {
    if (!this.goldenFollowOffers) {
      return null;
    }
    return this.goldenFollowOffers.filter((item: any) => {
      return item.way === "coin" && item.effect !== 0;
    });
  }

  private async checkIsShowDifference() {
    try {
      // 取出本地缓存:
    } catch (error) {
      //
    }
  }

  @Watch("activeIndex")
  private watchActiveIndex(val: any) {
    console.log("watchActiveIndex", val);
    if (val === 1) {
      this.checkIsShowDifference();
    }
    this.calcSwiperHeight(val);
  }

  // 监听是否拉取过最新setting
  @Watch("getterOnlineSettingsState", { immediate: true })
  private onlineSettingStateChange(val: any) {
    // 拉到线上setting之后执行开机弹窗逻辑
    if (val) {
      setTimeout(() => {
        // 必须是在首页才执行开机弹窗逻辑
        // const currentRoute = getCurrentRoute();
        // if (
        //   currentRoute &&
        //   currentRoute.path &&
        //   currentRoute.path.includes("/Home")
        // ) {
        //   getNotification() ? UmengPush.checkLaunchNotice() : generator.next();
        // }
        generator.next();
      }, 300);
    }
  }

  private buyOffer(offer: Offer) {
    payByAny({ offer });
  }
  private clickUserInfo() {
    if (this.currentInsUserInfo) {
      this.showInsGallery = true;
    } else {
      this.showSearchLogin();
    }
  }

  private toCoinStore() {
    //
    goToCoinStore();
  }

  private async reFreshInsUserInfo(done?: any) {
    try {
      await this.refreshCurrentUserInfo();
      done && done();
    } catch (error) {
      done && done();
    }
  }

  private intersection_observer_scroll() {
    const root_el = document.querySelector("#scroll-fixed-container");
    const target_el = (this.$refs.navTabBar as any).$el;
    //
    intersection_observer(
      root_el,
      target_el,
      ({ target_intersect, target_top, target_ratio }: any) => {
        if (target_top < 200 && target_ratio > 0) {
          // 避免ios弹性向下滚动，也会触发区域交叉
          this.fixedTabBarShow = !target_intersect;
        }
      }
    );
  }

  private calcSwiperHeight(val: number) {
    const currentSlide: any = (this.$refs["slideRef" + val] as any).$el;
    const calcHeight = currentSlide ? currentSlide.offsetHeight + "px" : "auto";
    console.log("currentSlide", {
      currentSlide,
      currentSlideOffestHeight: currentSlide.offsetHeight
    });
    // 如果计算的高度是0就不赋值
    if (
      currentSlide.offsetHeight &&
      calcHeight &&
      this.swiperHeight !== calcHeight
    ) {
      this.swiperHeight = calcHeight;
    }
  }

  private clickQuestion() {
    showFollowDifference();
  }

  private created() {
    this.updateSettingData(cgConst.TAB_FOLLOW_KEYS)
      .then(() => {
        // 线上setting的配置可能会多或者少，需要再次拉取一遍
        this.calcSwiperHeight(this.activeIndex);
        this.updatePageSettingStatus("follow");
      })
      .catch((e: any) => void 0);
  }

  private mounted() {
    this.$nextTick(() => {
      this.intersection_observer_scroll();
      this.calcSwiperHeight(this.activeIndex);
    });
  }

  private activated() {
    this.calcSwiperHeight(this.activeIndex);
  }

  private deactivated() {
    // 再次隐藏，避免回来时滚动是初始状态，但是还是显示了
    this.fixedTabBarShow && (this.fixedTabBarShow = false);
  }
}
